import { render, staticRenderFns } from "./account-preview.vue?vue&type=template&id=05423e19&scoped=true&"
import script from "./account-preview.vue?vue&type=script&lang=js&"
export * from "./account-preview.vue?vue&type=script&lang=js&"
import style0 from "./account-preview.vue?vue&type=style&index=0&id=05423e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05423e19",
  null
  
)

export default component.exports